export default __webpack_public_path__ + "25ff9cb.png";